import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { UserDetail, UsersUpdate } from '../store/slices/auth';
import Loader from '../common/Loader';
import AdminLayout from './AdminLayout';

const permissionsList = [
  'Invoices',
  'Credit Note',
  'Quotation',
  'Payment In',
  'Purchase Voucher',
  'Purchase Order',
  'Payment Out',
  'Debit Note',
  'Ledger',
  'Items',
  'Categories',
  'Closing Stock',
  'Pay/Rec/Cont',
  'Journal',
  'Bank Book',
  'Cash Book',
  'Closing Stock',
  'Business Reports',
  'Stock Reports',
  'GST Reports',
  'Audit Logs',
  'Settings',
  'Users',
  'Registers',
];

const EditUser = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userId } = useParams();

  const [isLoading, setIsLoading] = useState(false);

  const user = JSON.parse(localStorage.getItem('user'));
  const id = user?.data?.profile_id;

  const [formData, setFormData] = useState({
    profile_id: id,
    id: userId,
    name: '',
    email: '',
    profile_password: '',
    role: 'User',
    isActive: '0',
    permissions: [],
  });

  const [errors, setErrors] = useState({});

  const fetchUserDetails = async () => {
    setIsLoading(true);
    try {
      const data = await dispatch(UserDetail({ profile_id: id, user_id: userId })).unwrap();
      setIsLoading(false);
      console.log(data?.user?.data);
      setFormData((prevState) => ({
        ...prevState,
        name: data?.user?.data?.name,
        email: data?.user?.data?.email,
        // profile_password:data?.user?.data?.profile_password,
        role: 'User',
        isActive: data?.user?.data?.is_active,
        permissions: data?.user?.data?.permissions ? data?.user?.data?.permissions.split(',') : [],
      }));
    } catch (error) {
      setIsLoading(false);
      console.log('Error fetching :', error.message);
    }
  };

  console.log(formData);
  useEffect(() => {
    fetchUserDetails();
  }, [dispatch]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: type === 'checkbox' ? (checked ? 1 : 0) : value,
    }));
  };

  const handlePermissionChange = (permission) => {
    setFormData((prevState) => {
      const updatedPermissions = prevState.permissions.includes(permission) ? prevState.permissions.filter((perm) => perm !== permission) : [...prevState.permissions, permission];

      return { ...prevState, permissions: updatedPermissions };
    });
  };

  const validate = () => {
    let newErrors = {};
    if (!formData.name) newErrors.name = 'Name is required.';
    if (!formData.email) newErrors.email = 'Email is required.';
    // if (!formData.profile_password) newErrors.profile_password = 'Password is required.';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setIsLoading(true);
      dispatch(UsersUpdate(formData))
        .unwrap()
        .then(() => {
          setIsLoading(false);
          navigate('/user-list');
        })
        .catch(({ message }) => {
          setIsLoading(false);
          console.error(message);
        });
    }
  };

  return (
    <AdminLayout>
      {isLoading && <Loader />}
      <div className="row content-body">
        <div className="container">
          <div className="page-header">
            <div>
              <h2 className="main-content-title tx-24 mg-b-5">Users</h2>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="#">User</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Edit User
                </li>
              </ol>
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-md-8">
              <div className="card custom-card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>
                          Name <span className="required">*</span>
                        </label>
                        <input name="name" type="text" className="form-control" onChange={handleInputChange} value={formData.name} />
                        {errors.name && <span className="alert-message">{errors.name}</span>}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>
                          Email <span className="required">*</span>
                        </label>
                        <input name="email" type="text" className="form-control" onChange={handleInputChange} value={formData.email} />
                        {errors.email && <p className="alert-message">{errors.email}</p>}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Edit Password</label>
                        <input name="profile_password" type="text" className="form-control" onChange={handleInputChange} value={formData.profile_password} />
                        <p className="alert-message">Leave it blank, if you dont want to change password.</p>
                        {errors.profile_password && <p className="alert-message">{errors.profile_password}</p>}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group" style={{ marginTop: '2.2rem' }}>
                        <label>
                          <input type="checkbox" name="isActive" checked={formData.isActive == 0 ? false : true} onChange={handleInputChange} /> Active
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Permissions</label>
                    <div className="row mt-2">
                      {permissionsList.map((permission, index) => (
                        <div key={index} className="col-md-6">
                          <label>
                            <input type="checkbox" checked={formData.permissions.includes(permission)} onChange={() => handlePermissionChange(permission)} /> {permission}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="d-flex justify-content-start mt-4">
                    <button className="btn ripple btn-default" onClick={handleSubmit}>
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default EditUser;
